import React, { memo } from 'react'

import { useUnit } from 'effector-react'

import { useCallback } from 'hooks'

import Input from 'components/_old/Input/Input.jsx'
import LabelInlineStyle from 'components/_old/LabelInlineStyle/LabelInlineStyle.jsx'
import { Typo } from 'components/_old/Typo'

import { Paper } from 'components/atoms/Paper'
import { Typography } from 'components/atoms/Typography'
import { Validate } from 'components/atoms/Validate'

import { $form, $validation, setField } from '../../index'

const Amount = memo(() => {
  const [form, validation] = useUnit([$form, $validation])

  const handleChange = useCallback(
    (_, value: string | null) =>
      setField({
        field: 'amount',
        value,
      }),
    [],
  )

  return (
    <Validate rules={validation.amount.rules}>
      {(isValid) => (
        <LabelInlineStyle
          labelText="Amount to be transferred"
          errorMessages={validation.amount.errors}
          size="small"
          multiline
        >
          <Paper top={4} data-test-id="amountInput">
            <Input type="money" onChange={handleChange} withFloat valid={isValid} required>
              {form.amount ?? ''}
            </Input>
          </Paper>
          <Paper top={4}>
            <Typography size={12} color="additional">
              <Typo>Current pension value may change with markets</Typo>
            </Typography>
          </Paper>
        </LabelInlineStyle>
      )}
    </Validate>
  )
})
Amount.displayName = 'Amount'

export { Amount }
